export default "__VITE_ASSET__CiKf7fx1__"